
/// <amd-module name="Test/TestResultsGridToolbar/Actions/TestResultsToolbarActionCreator" />
import { TestResultToolBarSource } from "Test/TestResultsGridToolbar/Source/TestResultToolBarSource";
import { IVssPageContext } from "VSS/Platform/Context";

import { TestResultsToolbarActionsHub } from "Test/TestResultsGridToolbar/Actions/TestResultsToolbarActionshub";

export class TestResultsToolbarActionCreator {
	private source: TestResultToolBarSource;

	constructor(private _actionsHub: TestResultsToolbarActionsHub, private _pageContext: IVssPageContext) {
		this.source = new TestResultToolBarSource(this._pageContext);
	}

	public async getTestResultsSettings() {
		try {
			let testResultsSettings = await this.source.getTestResultsSettings(this._pageContext);
			if (!!testResultsSettings && !!testResultsSettings.flakySettings) {
				if(testResultsSettings.flakySettings.manualMarkUnmarkFlaky) {
					this._actionsHub.updateManualMarkUnMarkFlakyValue.invoke(true);
				}
				else {
					this._actionsHub.updateManualMarkUnMarkFlakyValue.invoke(false);
				}
			}
			else {
				this._actionsHub.updateManualMarkUnMarkFlakyValue.invoke(false);
			}
		} catch (error) {
			this._actionsHub.updateManualMarkUnMarkFlakyValue.invoke(false);
		}
	}
}
